const INCREMENT = "INCREMENT";
const INCREMENTEVENTTRACKER = "INCREMENTEVENTTRACKER";
const INITIALIZE = "INITIALIZE";
const SETINFO = "SETINFO";
const SETGAMEDATA = "SETGAMEDATA";
const GETGAMEINFO = "GETGAMEINFO";

const incrementCount = () => ({
    type: INCREMENT,
});

const incrementEventNbr = () => ({
    type: INCREMENTEVENTTRACKER,
});


const initializeApp = () => ({
       type: "INITIALIZE"
});


const setGameData = (value, dataname) => {
    return {
        type: SETGAMEDATA,
        payload: value,
        dataname
    };
};

const setInfo = (value, dataName) => {
    return {
        type: SETINFO,
        payload: value,
        dataName
    };
};

const getGameInfo = () => {
    return {
        type: GETGAMEINFO,
    };
};

export { INCREMENT, incrementCount, INCREMENTEVENTTRACKER, incrementEventNbr,
        setInfo, setGameData, SETINFO, SETGAMEDATA, getGameInfo, GETGAMEINFO,
        INITIALIZE, initializeApp };
